import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminNavbar from '../../Pages/Navbar/AdminNavbar';
import { Table, Button, Container, Row, Col, Card, Badge } from 'react-bootstrap';
import axios from 'axios';
import Swal from 'sweetalert2';
import './ManageShortlist.css';
import BaseUrl from '../../ApiServices/BaseUrl';

function ManageShortlist() {
  const [shortlists, setShortlists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchShortlists();
  }, []);

const fetchShortlists = async () => {
  try {
    const shortlistResponse = await axios.get(`${BaseUrl}/shortlist/all`);

    // ✅ Ensure response data is an array
    const shortlistData = Array.isArray(shortlistResponse.data)
      ? shortlistResponse.data
      : shortlistResponse.data.data || [];

    if (!Array.isArray(shortlistData) || shortlistData.length === 0) {
      console.warn("No shortlist records found");
      setShortlists([]);
      setLoading(false);
      return;
    }

    // ✅ Fetch employer details safely
    const shortlistsWithDetails = await Promise.all(
      shortlistData.map(async (shortlist) => {
        if (shortlist.employer_id) {
          try {
            const employerResponse = await axios.get(
              `${BaseUrl}/api/employer/by-user?user_id=${shortlist.employer_id}`
            );

            const employerData = Array.isArray(employerResponse.data)
              ? employerResponse.data[0]
              : null;

            return {
              ...shortlist,
              emp_name: employerData?.emp_name || "N/A",
              job_title: employerData?.job_title || "N/A",
              domestic_worker_category:
                employerData?.domestic_worker_category || "N/A",
              job_type: employerData?.job_type || "N/A",
              working_city: employerData?.working_city || "N/A",
              state_or_province: employerData?.state_or_province || "N/A",
              minimum_monthly_salary:
                employerData?.minimum_monthly_salary || "N/A",
              maximum_monthly_salary:
                employerData?.maximum_monthly_salary || "N/A",
            };
          } catch (err) {
            console.error(
              `Error fetching employer details for employer_id ${shortlist.employer_id}:`,
              err
            );
            return shortlist;
          }
        } else {
          return shortlist;
        }
      })
    );

    console.log("✅ Final Shortlist Data:", shortlistsWithDetails);
    setShortlists(shortlistsWithDetails);
    setLoading(false);
  } catch (err) {
    console.error("❌ Error fetching shortlists:", err);
    setError(err.message);
    setLoading(false);
  }
};


//   const handleAddShortlist = () => {
//     navigate('/shortlistform');
//   };

  const handleViewDetails = (id) => {
    navigate(`/shortlist-details/${id}`);
  };

  const confirmDelete = (shortlist) => {
    Swal.fire({
      title: 'Are you sure?',
      text: `You are about to remove "${shortlist.first_name}" from shortlist`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, remove it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`${BaseUrl}/api/shortlist/${shortlist.id}`);
          setShortlists(shortlists.filter(item => item.id !== shortlist.id));
          
          Swal.fire(
            'Removed!',
            'The candidate has been removed from shortlist.',
            'success'
          );
        } catch (err) {
          Swal.fire(
            'Error!',
            err.response?.data?.error || 'Failed to remove candidate',
            'error'
          );
        }
      }
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      });
    } catch (e) {
      return 'N/A';
    }
  };

  if (loading) return (
    <>
      <AdminNavbar />
      <div className="text-center mt-5" style={{ marginTop: '100px' }}>Loading shortlists...</div>
    </>
  );
  
  if (error) return (
    <>
      <AdminNavbar />
      <div className="text-center mt-5 text-danger" style={{ marginTop: '100px' }}>Error: {error}</div>
    </>
  );

  return (
    <>
      <AdminNavbar />
      <Container className="" style={{ marginTop: '80px' }}>
   <Row className="mb-4 manageshortlist-text">
  <Col style={{ marginTop: '20px' }}>
    <h2>Manage Shortlist</h2>
    <p className="text-muted">View and manage shortlisted candidates</p>
  </Col>
  <Col className="text-end">
    {/* Optional button here */}
  </Col>
</Row>

<div className='manageshortlisthead'>

        <Card>
          <Card.Body>
<div className="manageshortlist">
              <div className="table-responsive">
              <Table striped bordered hover responsive>
                <thead className="table-dark">
                  <tr>
                    <th>ID</th>
                    <th>Candidate Name</th>
                    <th>Email</th>
                    <th>Job Title</th>
                    <th>Employer</th>
                    <th>Source</th>
                    <th>Status</th>
                    <th>Created Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {shortlists.map((shortlist) => (
                    <tr key={shortlist.id}>
                      <td>{shortlist.id}</td>
                      <td className="fw-semibold">{shortlist.first_name}</td>
                      <td>{shortlist.email_id}</td>
                      <td>{shortlist.job_title || 'N/A'}</td>
                      <td>{shortlist.emp_name || 'N/A'}</td>
                      <td>{shortlist.employer_source || 'Direct'}</td>
                      <td>
                        <Badge bg="primary">
                          Shortlisted
                        </Badge>
                      </td>
                      <td>{formatDate(shortlist.created_at)}</td>
                      <td>
                        <div className="d-flex gap-2">
                          <Button 
                            variant="outline-info" 
                            size="sm"
                            onClick={() => handleViewDetails(shortlist.id)}
                          >
                            View
                          </Button>
                          {/* <Button 
                            variant="outline-danger" 
                            size="sm"
                            onClick={() => confirmDelete(shortlist)}
                          >
                            Remove
                          </Button> */}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              
              {shortlists.length === 0 && (
                <div className="text-center py-4">
                  <p className="text-muted">No shortlisted candidates found.</p>
                  {/* <Button variant="primary" onClick={handleAddShortlist}>
                    Add First Candidate
                  </Button> */}
                </div>
              )}
            </div>
            </div>
          </Card.Body>
        </Card>
        </div>
      </Container>
    </>
  );
}

export default ManageShortlist;